import { tieneSesionActiva } from '@/lib/auth';
import { Navigate, useLocation } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

/**
 * Wrapper que protege rutas autenticadas. Si no hay sesión válida
 * redirige a /login preservando el destino al que el usuario intentaba ir.
 *
 * En modo dev (VITE_AUTH_DEV_MODE=true) tieneSesionActiva() retorna true
 * siempre, así que el wrapper es transparente.
 */
export function RequiereAuth({ children }: Props) {
  const location = useLocation();

  if (!tieneSesionActiva()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
